export * from './src/input-geolocation.component';
